import React from 'react';
import { useTranslation } from 'react-i18next';
import GridContainer from '../../../../Grid/GridContainer';
import GridItem from '../../../../Grid/GridItem';
import { DialogTrasladoEditProps } from '../types';
import { useDialogTraslado } from '../useDialogTraslado';
import TransferServiceInfoEdit from '../components/TransferServiceInfoEdit';
import TransferMapSection from '../components/TransferMapSection';
import { buildTransferEditFormData } from '../utils/buildTransferEditFormData';
import ButtonSpinner from '../../../../ButtonSpinner';
import {  CheckCircleOutline, Clear } from '@material-ui/icons';
import { Color } from '../../../../../util/interfaces';

const ModalCalendarTransferEdit: React.FC<DialogTrasladoEditProps> = (props) => {
  const { t } = useTranslation();
  const {
    state,
    isReady,
    formatTransferTypeRecive,
    formatDistance,
    translateStatus,
    formatPatientAddress,
    canAssignDriver,
    getStatus,
    handleToPDF,
    getTransferWayLabel,
    handleValue,
    handleTimeChange,
    isEditable,
    isOneWay,
    canSubmit,
    checked,
    isLoading,
    errors,
    handleVerify,
    handleSubmit
  } = useDialogTraslado(props);

  if (!isReady) {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            {String(t('common.loading'))}
          </div>
        </GridItem>
      </GridContainer>
    );
  }

  const formData = buildTransferEditFormData(state, props.event, props?.drivers || [], props.idTransfer);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={6} style={{ width: '100%' }}>
        <div style={{ width: '100%' }}>
          <TransferServiceInfoEdit
            event={props.event}
            appointment={props.appointment}
            formatTransferTypeRecive={formatTransferTypeRecive}
            formatDistance={formatDistance}
            translateStatus={translateStatus}
            formatPatientAddress={formatPatientAddress}
            getTransferWayLabel={getTransferWayLabel}
            isOneWay={isOneWay}
            t={t}
            state={state}
            handleValue={handleValue}
            drivers={props.drivers}
            handleTimeChange={handleTimeChange}
            isEditable={isEditable}
            dates={{endDate: props?.appointment?.endDate, startDate: props?.appointment?.startDate}}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={12} md={6} style={{ width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
          <div style={{ width: '100%' }}>
            <TransferMapSection
              customer={props.customer}
              event={props.event}
              state={state}
              getStatus={getStatus}
              handleToPDF={handleToPDF}
              canAssignDriver={canAssignDriver}
              t={t}
            />
          </div>
          {errors && (
            <div style={{ color: 'red', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
              <Clear style={{ color: 'red' }} />
              {errors.map((e: any, i: number) => (
                <div key={i}>{e.detail}</div>
              ))}
            </div>
          )}
          {!errors && checked && (
            <div style={{ color: 'green', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
              <CheckCircleOutline style={{ color: 'green', fontSize: '80px' }} />
              <div>{String(t('Verificación exitosa'))}</div>
            </div>
          )}
          {isEditable() && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <ButtonSpinner
                id="button-verify"
                label={String(t('common.check'))}
                labelLoading={String(t('common.loading'))}
                loading={isLoading}
                onClick={() => handleVerify(formData, props.event.id)}
                color={Color.primary}
                typeButton="button"
              />
              <ButtonSpinner
                id="button-submit"
                label={String(t('common.accept'))}
                labelLoading={String(t('common.saving'))}
                loading={false}
                onClick={() => {
                  handleSubmit(formData, props.event.id, () => {
                    if (props.onScheduleUpdate) {
                      props.onScheduleUpdate(
                        formData.transferScheduleId,
                        formData.scheduleTransferDateTime,
                        formData.scheduleTransferEndDateTime
                      );
                    }
                    if(props.onBookingUpdate){
                      props.onBookingUpdate(formData)
                    }
                    if (props.onCloseModal) {
                      props.onCloseModal();
                    }
                  },
                  props.isBookingUpdate
                );
                }
              }
                disabled={!canSubmit}
                color={Color.success}
                typeButton="button"
              />
            </div>
          )}
        </div>
      </GridItem>
    </GridContainer>
  );
};

export default ModalCalendarTransferEdit; 